import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div className="footer bg-footer p-3">
        <p className="text-white mb-0 fs-14 fw-100">
          © Copyright 2019 Code&CO. All rights Reserved
        </p>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/index.jsx